import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=3295fdfd&scoped=true"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"
import style0 from "./extension.vue?vue&type=style&index=0&id=3295fdfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295fdfd",
  null
  
)

export default component.exports